function isAnchor(props) {
  return props.href !== void 0;
}
function isLink(props) {
  return props.href !== void 0 || props.to !== void 0;
}
export {
  isAnchor,
  isLink
};
//# sourceMappingURL=utils.es.js.map
